// Component: EmptyState.jsx
// Purpose: DS empty state — centered icon + title + description + optional action.
//   For empty lists/tables/panels. Styling in ds-components.css.

import React from "react";
import { cx } from "./cx";

export function EmptyState({ icon, title, description, action, className, ...props }) {
  return (
    <div className={cx("ds-empty", className)} {...props}>
      {icon && <div className="ds-empty-icon">{icon}</div>}
      {title != null && <div className="ds-empty-title">{title}</div>}
      {description != null && <div className="ds-empty-desc">{description}</div>}
      {action && <div className="ds-empty-action">{action}</div>}
    </div>
  );
}

export default EmptyState;
